/* eslint-disable */
import React from 'react'
import { Dashboard } from '@uppy/react'
import GoldenRetriever from '@uppy/golden-retriever';
import PropTypes from 'prop-types';
import UppyClient from './UppyClient';

import './style.scss';
import ProviderConfig from './ProviderConfig';
class UppyUploader extends React.Component {
  constructor (props) {
    super(props)

    const providers = ProviderConfig(props)
    this.pluginsProp = [
      ...providers.pluginsProp,
      'ImageEditor',
      'LoadingStatus'
    ];

    let sendPlugins = providers.plugins

    if (props.recoverFiles) {
      sendPlugins = [...sendPlugins, [GoldenRetriever, {}]]
    }

    this.uppy = UppyClient(
      props,
      sendPlugins
    );
  }

  componentWillUnmount() {
    // `uppy.close` or `uppy.cancelAll` should be called on unmount to allow for the
    // functioning of the onFileRemoved callback behavior. `close` or `cancelAll` methods cause
    // a `file-removed` event to be emitted by Uppy which we rely on for the onFileRemoved callback.
    this.uppy.close();
  }

  render () {
    return (
      <>
        <Dashboard
          proudlyDisplayPoweredByUppy={false}
          autoOpenFileEditor={this.props.autoOpenFileEditor}
          hideCancelButton
          uppy={this.uppy}
          plugins={this.pluginsProp}
          metaFields={[
            { id: 'name', name: 'Name', placeholder: 'File name' },
          ]}
        />
      </>
    )
  }
}

const defaultFn = () => {};

UppyUploader.defaultProps = {
  onError: defaultFn,
  onSuccess: defaultFn,
  onComplete: defaultFn,
  signature: "",
  path: "",
  bucket: "",
  storeAccess: "private",
  assetName: "Video",
  maxSize: 5368709120, // 5 GB
  multiple: false,
  maxFiles: 1,
  sources: [],
  extensions: null,
  debug: false,
  autoProceed: false,
  recoverFiles: false,
}

UppyUploader.propTypes = {
  tusdUrl: PropTypes.string.isRequired,
  companionUrl: PropTypes.string.isRequired,
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
  onComplete: PropTypes.func,
  signature: PropTypes.string,
  path: PropTypes.string.isRequired,
  bucket: PropTypes.string.isRequired,
  storeAccess: PropTypes.oneOf(['private', 'public']),
  assetName: PropTypes.string,
  maxSize: PropTypes.number,
  multiple: PropTypes.bool,
  maxFiles: PropTypes.number,
  sources: PropTypes.array,
  extensions: PropTypes.string,
  debug: PropTypes.bool,
  autoProceed: PropTypes.bool,
  recoverFiles: PropTypes.bool,
}

export default UppyUploader;
